module.exports = __webpack_public_path__ + "static/media/dqIndexIpad.0636e0f6.png";